export default __webpack_public_path__ + "assets/images/c53f57af2d882badef7b15684c6ee291.svg";